<script setup>
import { useBroadcastChannel } from '@vueuse/core';
import { watch, ref, onMounted } from 'vue';
import { useAuthStore } from './stores/auth';
import { useRoute } from 'vue-router'
import { computed, provide } from 'vue'
import MainLayout from '@/layouts/mainLayout.vue'
import AuthLayout from '@/layouts/authLayout.vue';
import HojaGastoLayout from '@/layouts/hojagastoLayout.vue';
import TableroLayout from '@/layouts/tableroLayout.vue';
import FormAntecedenteMedicoLayout from './layouts/FormAntecedenteMedicoLayout.vue';
import { useGlobalLoading } from '@/stores/loading.js'
import AuthModals from '@/components/AuthModals.vue'
const authStore = useAuthStore();
const isAppReady = ref(false);
const {
  isSupported,
  data,
  post,
  error,
} = useBroadcastChannel({ name: 'logout-channel' })

/*Evento broadcast channel */
watch(data, async (newValue) => {
  if (newValue && newValue !== "") {
    // console.log(`Event BroatCast Channel:${newValue}`)
  }
})
// Escoge layout usar

const route = useRoute()


const layoutComponent = computed(() => {
  const layout = route.meta.layout || 'AuthLayout'
  // console.log('layout', layout)
  return {
    MainLayout,
    AuthLayout,
    HojaGastoLayout,
    TableroLayout,
    FormAntecedenteMedicoLayout,
  }[layout] || AuthLayout // fallback seguro
})

const path = computed(() => {
  return route.name;
});

provide('path', path);

onMounted(async () => {
  await authStore.checkAuth(); // Valida si el usuario sigue logueado
  isAppReady.value = true;
});

</script>
<template>
  <AuthModals />
  <component v-if="isAppReady" :is="layoutComponent">      
    <template #main>
      <router-view />
    </template>
  </component>
</template>